// 供应商
import api from "../api/api";
import { SET_C_USER, SET_AVATAR } from "./mutation-types";

const cUserInfo = JSON.parse(localStorage.getItem("cUserInfo")) || {};
export default {
  state: {
    cUserInfo: cUserInfo,
    headPhoto: ""
  },
  mutations: {
    [SET_C_USER](state, data) {
      state.cUserInfo = data;
    },
    [SET_AVATAR](state, data) {
      state.headPhoto = data;
    }
  },
  actions: {
    getCUser({ commit }) {
      return new Promise((resolve, reject) => {
        api.clogin
          .getUserInfo({})
          .then(res => {
            commit(SET_C_USER, res.data);
            localStorage.setItem("cUserInfo", JSON.stringify(res.data));
            commit(SET_AVATAR, res.data.UserHeadPhoto);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
